<template>
  <v-container fluid>

    <v-row dense>
      <v-col cols="12" md="4">
        <profile />
        <loyalty />
        <social-networks />
      </v-col>
      <v-col cols="12" md="8">
        <comments
          v-if="!$store.state.auth.checkAccess({key: 'hide_comments', value: true})"
          @show-manual-notification="$emit('show-manual-notification')"
        />

        <v-row class="ml-0">
          <v-col cols="12" :md="5">
            <account-details />
          </v-col>
          <v-col cols="12" :md="7" :class="{'pl-0': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'}">
            <kyc />
            <finance />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col :cols="12">
        <behavior-stats />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col :cols="12">
        <duplicates />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col :cols="12">
        <recent-transactions />
      </v-col>
    </v-row>


  </v-container>
</template>


<script>

  import SocialNetworks from '@/components/user/dashboard/SocialNetworks'

  export default {
    components: {
      SocialNetworks,
      RecentTransactions: () => import('@/components/user/dashboard/RecentTransactions'),
      Finance: () => import('@/components/user/dashboard/Finance'),
      Kyc: () => import('@/components/user/dashboard/KYC'),
      MaterialCard: () => import('@/components/material/Card'),
      Profile: () => import('@/components/user/dashboard/Profile'),
      AccountDetails: () => import('@/components/user/dashboard/AccountDetails'),
      Comments: () => import('@/components/user/dashboard/Comments'),
      Loyalty: () => import('@/components/user/dashboard/Loyalty'),
      Duplicates: () => import('@/components/user/dashboard/Duplicates'),
      BehaviorStats: () => import('@/components/user/dashboard/behavior/behavior-stats.vue'),
    },
    props: [],
    data: () => ({})
  }
</script>
